export function parsePermitTime(time, isEnd = false) {
  if (!time) return
  // permit_start, permit_endは20180420の形式
  // これをそのままDate.parseできないので、整形してparse
  const timeStr = isEnd ? ' 23:59:59 +0900' : ' 00:00:00 +0900'
  return Date.parse(time.substring(0, 4) + '/' + time.substring(4, 6) + '/' + time.substring(6, 8) + timeStr)
}
